module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAA4AAAAPCAYAAADUFP50AAAAAXNSR0IArs4c6QAAAPZJREFUKBWdUTEKhDAQ3Bz3BQUbK1vfJVjZ2dla608En2DvB8ROREQsBK00lwkkGE+vuGkmszO7YRPGBegPvH71pGn6aP9snKbpv8bHLmE83rgsC3VdR+Bb4HHuEMcxL4qCg+/wdeM8z5TnOTVNQ9u20TiOUqNu4DytrmseBAFv2/Zclhp1+AqkDmIiD8OQ7/uuSgajDh85QDcmScKHYTDCVwEfOUDvuK4r2bZtrHEV8JED3sqsqorECyr5xb7vk2VZhBygG13X1eG+78lxHEMroXPXPaDFd/CyLKUFhr6CoaCmKT6Og7Isk3/peR5FUUSMMWVL/gC3EkQjVFkqJwAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/techo-y-pared.png
// module id = 519
// module chunks = 0